import SyncData from './components/sync-data';
import {getUserInfo} from './firebase/user';
import {setAirline, setRole, setUser} from './redux/slice/userSlice';
import {UserRole} from './services/tmm';
import {auth} from '@/config/firebase';
import {useAppDispatch, useAppSelector} from '@/hooks/redux';
import i18n from '@/i18n';
import router from '@/router';
import moment from 'moment';
import {useEffect} from 'react';
import {useAuthState} from 'react-firebase-hooks/auth';
import {RouterProvider} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function App(): JSX.Element {
  const dispatch = useAppDispatch();
  const [user] = useAuthState(auth);
  const language = useAppSelector((state) => state.app.language);

  useEffect(() => {
    dispatch(setAirline(localStorage.getItem('airline') || 'SIA'));
    if (user) {
      void getUserInfo(user.uid).then((user) => {
        const userInfo: any = {};
        user.forEach((user) => {
          if (!user.key) return;
          userInfo[user.key] = user.val();
        });
        dispatch(setUser(userInfo));
        dispatch(setRole(userInfo?.role || UserRole.PILOT));
      });
    }
  }, [user]);
  moment.prototype.fromNow = function (a: boolean) {
    // if in day return fromNowText
    moment.updateLocale('en', {
      relativeTime: {
        future: 'in %s',
        past: '%s',
        s: '%ds',
        ss: '%ds',
        m: '1m',
        mm: '%dm',
        h: '1h',
        hh: '%dh',
        d: '1d',
        dd: '%dd',
        M: '1mth',
        MM: '%dmth',
        y: '%y',
        yy: '%dy'
      }
    });
    return this.from(moment(), a);
  };

  useEffect(() => {
    void i18n.changeLanguage(language);
  }, [language]);

  return (
    <div className="min-h-screen w-full">
      <RouterProvider router={router} />
      <ToastContainer className="app-toast-container" />
      <SyncData />
    </div>
  );
}
